import ApiService from 'common/service/api';
import { PublicError } from 'common/service/error';
import { catchError, map } from 'rxjs/operators';

export default class JobServiceWS extends ApiService {
  constructor(config) {
    super(config);

    this.baseURL = `/ws`;
  }

  getJobByName(jobName) {
    return this.fetchResource(`/queryMeterJob/${jobName}`);
  }

  checkForMeterExistence(groupDetails) {
    return this
    .post(`/meterGroup`, groupDetails)
    .pipe(
      map(ApiService.resourceJson),
      catchError((err) => {
        if (err.status === 400 && err.response) {
          throw err;
        }
        throw err;
      }),
    );
  }

  runGetJob(payload){
    return this
    .post('/meterJob', payload)
    .pipe(
      map(ApiService.resourceJson),
      catchError((err) => {
        if (err.status === 400 && err.response) {
          throw new PublicError("failed", err.response.message, "failed");
        }
        throw err;
      }),
    );
  }

}



